module.exports = __webpack_public_path__ + "static/media/PMG logo-80.92df923a.svg";